import React from 'react';

/** Cross-ventilation (CV) icon — Noun Project 54559, cropped; fill + stroke for heavier weight. */
const CvIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="-4 -6 106 92"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="5"
    strokeLinejoin="round"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    {/* Roof */}
    <path d="M15 33.16C15 29.43 15.49 28.9 32.11 14.58L49.21-.15L51.36 1.76C52.53 2.8 60.02 9.23 68 16.04C75.97 22.85 82.83 28.89 83.23 29.46C83.64 30.03 83.98 31.96 83.98 33.75C84 36.34 83.59 37 82 37C80.49 37 80 36.33 79.99 34.25C79.98 31.94 77.49 29.36 64.55 18.28L49.11 5.05L34.06 18.08C21.01 29.37 19 31.5 19 34.06C19 36.33 18.55 37 17 37C15.35 37 15 36.33 15 33.16Z" />
    {/* Airflow left */}
    <path d="M26.19 51.28C27.57 49.61 27.47 49.53 21.81 48.15C15.24 46.54 6.45 46.72 2.95 48.53C1.33 49.36 0 49.62 0 49.1C0 48.58 2.49 46.93 5.54 45.44C10.65 42.94 11.77 42.77 20.06 43.24C27.65 43.67 29.19 43.5 29.99 42.13C30.51 41.23 30.95 40.98 30.97 41.57C30.99 42.16 32.55 44.45 34.44 46.66L37.89 50.69L31.49 51.64C26.21 52.43 25.28 52.37 26.19 51.28Z" />
    {/* Airflow right */}
    <path d="M63.25 51.57C61.46 50.76 60 49.96 60 49.8C60 49.63 63.49 49.48 67.75 49.45C74 49.41 76.64 48.88 81.42 46.68C86.97 44.13 87.21 43.87 85.42 42.51C83.66 41.18 83.91 41.06 88.5 41.02C91.25 40.99 94.48 40.71 95.67 40.39C97.74 39.83 97.69 40.1 94.68 45.85C92.07 50.82 91.38 51.55 90.79 49.97C90.09 48.07 89.99 48.08 85.29 50.14C79.09 52.87 67.73 53.6 63.25 51.57Z" />
    {/* Walls + floor */}
    <path d="M15 67.43C15 57.9 15.17 56.89 16.75 57.19C18.22 57.47 18.55 58.85 18.79 65.76L19.08 74L49.54 74L80 74L80 65.43C80 57.8 80.19 56.89 81.75 57.19C83.26 57.48 83.54 58.94 83.78 67.76L84.07 78L49.53 78L15 78L15 67.43Z" />
  </svg>
);

export default CvIcon;
